module.exports = __webpack_public_path__ + "img/discount-percentage-icon.523696a1.svg";